module.exports = __webpack_public_path__ + "img/no-alpaca.02592acd.svg";